import React, { useContext } from "react";
import { LayoutContext, constants } from "./LayoutContext";
import IconSun from "../assets/dazzle-sun.svg";
import IconMoon from "../assets/dazzle-moon.svg";

export const TopbarTheme = () => {
  // TopbarBranding
  const layoutContext = useContext(LayoutContext);
  const { theme, sidebarOpen, toggleTheme, toggleSidebar } = layoutContext;
  return (
    <div className="topbar-icon top-menu-button" id="topbar-icon toggle-theme">
      {theme === constants.THEME_LIGHT ? (
        <IconMoon className="topbar-svg-icon" onClick={() => toggleTheme()} />
      ) : (
        <IconSun className="topbar-svg-icon" onClick={() => toggleTheme()} />
      )}
    </div>
  );
};
